import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import questionActions from 'store/question/actions';
import quizActions from 'store/quiz/actions';
import alertActions from 'store/alert/actions';
import removeUrlParamRaw from 'store/extra/actions/removeUrlParam';

import GoogleAdsense from 'components/GoogleAdsense';
import OptionList from 'components/OptionList';

import event from '../../utils/event/event';

import {
  SubmitButton,
  SkipLink,
  QuestionText,
} from './TriviaQuestion.styles';


export class TriviaQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenAnswer: null,
    };
  }

  componentDidMount() {
    const {
      submitQuestion,
      removeUrlParam,
      question,
      answerId,
      id,
    } = this.props;

    if (answerId) {
      const answer = question.answer_set.find((ans) => ans.id === Number(answerId));
      submitQuestion({ question: id, answer })
        .then(() => {
          removeUrlParam(`answerId`);
        })
        .catch(() => {
          removeUrlParam(`answerId`);
        });
    }
  }

  handleSkip = () => {
    const { id, skipQuizQuestion } = this.props;
    skipQuizQuestion();
    event(`question-skip`, [`click`, `question-skip`, `${id}`]);
  }

  chooseAnswer = (e) => {
    const chosenAnswer = e.currentTarget.getAttribute(`value`);
    this.setState({
      chosenAnswer: Number(chosenAnswer),
    });
  }

  handleSubmitQuestionPlaythrough = (e) => {
    const { chosenAnswer } = this.state;
    const {
      addAlert,
      question,
      submitQuestion,
      id,
    } = this.props;

    // preventDefault prevents redirecting to results page before question has been submitted
    e.preventDefault();
    const answer = question.answer_set.find((ans) => ans.id === chosenAnswer);
    if (!answer) {
      addAlert({
        message: `You need to choose an option!`,
        type: `danger`,
      });
    } else {
      submitQuestion({ question: id, answer });
    }
  }

  render() {
    const { chosenAnswer } = this.state;
    const {
      question,
      questionMeta,
      resultMeta,
      id,
      session: { questionsIds },
    } = this.props;

    const skipLink = question.verified || questionsIds.length <= 1
      ? (<SkipLink
        onClick={this.handleSkip}
        to={`/question/${questionsIds[1]}`}
      > Skip Question </SkipLink>) : null;

    // Checks if user answer for question is submitting/submitted to redirect to results page
    if (questionMeta
      && (questionMeta.submitting || questionMeta.submitted)
      && (!resultMeta || !resultMeta.error)) {
      return (
        <Redirect to={`/question/${id}/results`} />
      );
    }

    return (
      <>
        <QuestionText>
          {question.content}
        </QuestionText>
        <OptionList
          answers={question.answer_set}
          chosenAnswer={chosenAnswer}
          chooseAnswer={this.chooseAnswer}
        />
        <SubmitButton
          to={`/question/${id}/results`}
          onClick={this.handleSubmitQuestionPlaythrough}
          type="primary"
        >
          Submit Answer
        </SubmitButton>
        <GoogleAdsense
          slot="3570708028"
          format="auto"
          style={{ width: `300px`, height: `250px`, display: `block`, marginTop: `32px` }}
        />
        {skipLink}
      </>
    );
  }
}

TriviaQuestion.propTypes = {
  question: PropTypes.object,
  addAlert: PropTypes.func,
  submitQuestion: PropTypes.func,
  removeUrlParam: PropTypes.func,
  answerId: PropTypes.string,
  questionMeta: PropTypes.object,
  resultMeta: PropTypes.object,
  id: PropTypes.number,
  session: PropTypes.object,
  skipQuizQuestion: PropTypes.func,
};

export default connect((state, { id }) => {
  return {
    questionMeta: state.question.meta[id],
    resultMeta: state.result.meta[id],
    session: state.quiz.session,
  };
},
{
  submitQuestion: questionActions.submitQuestion,
  removeUrlParam: removeUrlParamRaw,
  addAlert: alertActions.createAlert,
  skipQuizQuestion: quizActions.skipQuizQuestion,
})(TriviaQuestion);
